import React, { useState } from 'react';

import type { DrawReactComponentProps } from '@aline/common';
import { EditorPopover } from 'src/components';
import { VariablePopoverContent } from 'src/editor/popovers';
import { IS_MOBILE } from 'src/helpers/environment';

export function DynamicBlockPopoverAnchor({
  dynamicBlockEntry,
  height,
  width,
}: DrawReactComponentProps['DynamicBlockPopoverAnchor']) {
  const [reference, setReference] = useState<HTMLDivElement | null>(null);

  return (
    <>
      <div
        ref={setReference}
        style={{ height, pointerEvents: 'none', position: 'absolute', width }}
      />

      {!IS_MOBILE && (
        <EditorPopover placement="bottom" reference={reference}>
          <VariablePopoverContent fieldEntry={dynamicBlockEntry} />
        </EditorPopover>
      )}
    </>
  );
}
